module.exports = __webpack_public_path__ + "6185565f0ada2cbb6ac21e46ce1e0299.svg";